__turbopack_context__.v({
  "shell": "AccommodationStaysMapSheet-module__JdcGkG__shell",
  "shellMessage": "AccommodationStaysMapSheet-module__JdcGkG__shellMessage",
});
